import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'IrisSearchAltMessageLazy',
        path: () => path.join(__dirname, './SearchAltMessage'),
        resolve: () => require.resolveWeak('./SearchAltMessage'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "IrisSearchAltMessageLazy" */ './SearchAltMessage'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
